/**
 * Query used to get all questions associated with an RFXRequest.
 * Below are the list of services that it talks to:
 * AWSSCMRFXService
 */
import { gql } from '@apollo/client';

import { processResponse } from './helper';

export const getRFXQuestionsForRequestQuery = gql`
  query getRFXQuestionsForRequest(
    $rfxRequestRevisionedId: RFXRevisionedIdInput!
    $nextToken: String
    $maxResults: Int
  ) {
    getRFXQuestionsForRequest(
      rfxRequestRevisionedId: $rfxRequestRevisionedId
      nextToken: $nextToken
      maxResults: $maxResults
    ) {
      rfxQuestions {
        rfxQuestionRevisionedId {
          id {
            value
          }
          revision
        }
        rfxQuestionVersion
        rfxRequestRevisionedId {
          id {
            value
          }
          revision
        }
        author {
          userType
          id {
            value
          }
        }
        rfxQuestionClassId {
          value
        }
        title
        message
        contentType
        answers {
          rfxAnswerRevisionedId {
            id {
              value
            }
            revision
          }
          rfxAnswerVersion
          author {
            userType
            id {
              value
            }
          }
          message
          contentType
          comments {
            rfxCommentRevisionedId {
              id {
                value
              }
              revision
            }
            rfxCommentVersion
            author {
              userType
              id {
                value
              }
            }
            message
            contentType
            createdAt
            lastUpdatedAt
          }
          createdAt
          lastUpdatedAt
        }
        comments {
          rfxCommentRevisionedId {
            id {
              value
            }
            revision
          }
          rfxCommentVersion
          author {
            userType
            id {
              value
            }
          }
          message
          contentType
          createdAt
          lastUpdatedAt
        }
        createdAt
        lastUpdatedAt
        properties {
          id {
            value
          }
          value {
            valueString {
              value
            }
            dataType {
              value
            }
          }
        }
        rfxQuestionDocuments {
          documentType
          supplierIds {
            value
          }
          attachment {
            externalId
            version
            filename
            size
            format
            description
            stagingS3Uri
            status
            createdDate {
              value
              format
            }
          }
        }
      }
    }
  }
`;

export default function getRFXQuestionsForRequest(this: any, request: any) {
  return processResponse(
    this.query({
      query: getRFXQuestionsForRequestQuery,
      variables: request,
      fetchPolicy: 'network-only'
    }),
    'getRFXQuestionsForRequest'
  );
}
